(ns ycweb.app.website.auth.erasure
  "The link emailed when someone asks us to delete their account
   (auth.api.erasure): they confirm it was them, or keep the account. Nothing
   is deleted from here; a second admin approves afterwards."
  (:require
   [rum.core :as rum]
   [ycweb.app.website.auth.common :as auth.cmn]
   [ycweb.app.website.website :as website]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.urlstate :as urlstate]))

(defn- link-token [app-atom]
  (:t (cmn/screen-params app-atom)))

(defn- answer! [app-atom decision]
  (toaster/open-overlay app-atom :web.login/erasure-review)
  (comms/ajax-post :web.auth/erasure-answer
    {:token (link-token app-atom)
     :decision decision}))

;; ========== REVIEW: CONFIRM OR KEEP ==========
(rum/defc review-modal-body < rum/reactive [app-atom _ _]
  [:<>
   [:div.modal__header
    (headings/heading "Delete your account?" {:type :h2 :size :default :flush true :class "modal__heading"})]
   [:div.modal__content
    [:p.yc-paragraph "We've received a request to delete your Yuppiechef account and the personal information we hold about you."]
    [:p.yc-paragraph "Once it's done, it can't be undone: you won't be able to sign in, and your order history, addresses, reviews and registries will be removed. We keep invoices for as long as tax law requires."]
    [:p.yc-paragraph "Did you ask for this?"]]
   (toaster/loading-overlay app-atom :web.login/erasure-review)])

(rum/defc review-modal-footer < rum/reactive [app-atom _ _]
  [:div
   (grid/button-row
     {:left-text "No, keep my account"
      :left-fn #(answer! app-atom "decline")
      :left-no-icon true
      :right-text "Yes, delete my account"
      :right-fn #(answer! app-atom "confirm")
      :right-no-icon true})])

(defmethod grid/modal-config :web.login/erasure-review [_ _ _]
  {:body-raw review-modal-body
   :footer review-modal-footer
   :modal-type :variable
   :cancel-key :auth-modal-close})

;; ========== OUTCOME: CONFIRMED, KEPT OR NO LONGER VALID ==========
(def ^:private outcome-headings
  {:web.login/erasure-confirmed "Thanks for confirming"
   :web.login/erasure-cancelled "Your account stays"
   :web.login/erasure-expired "Link no longer valid"})

(rum/defc outcome-modal-body < rum/reactive [_app-atom config-atom _]
  (let [{:keys [heading msg]} (rum/react config-atom)]
    [:<>
     [:div.modal__header
      (headings/heading heading {:type :h2 :size :default :flush true :class "modal__heading"})]
     [:div.modal__content
      [:p.yc-paragraph msg]]]))

(rum/defc outcome-modal-footer < rum/reactive [app-atom _ _]
  [:div
   (grid/button-row
     {:single-text "Continue to Yuppiechef"
      :single-fn #(urlstate/raw-redirect app-atom "/")})])

(def ^:private outcome-modal
  {:body-raw outcome-modal-body
   :footer outcome-modal-footer
   :modal-type :variable
   :cancel-key :auth-modal-close})

(defmethod grid/modal-config :web.login/erasure-confirmed [_ _ _] outcome-modal)
(defmethod grid/modal-config :web.login/erasure-cancelled [_ _ _] outcome-modal)
(defmethod grid/modal-config :web.login/erasure-expired [_ _ _] outcome-modal)

(defn- show!
  "The screen the answer names. A refusal (too many tries) has no action, so
   it shows as a link that no longer works, with its message."
  [app-atom {:keys [action msg]}]
  (toaster/close-overlay app-atom :web.login/erasure-review)
  (grid/close-modal app-atom)
  (grid/open-modal app-atom (or action :web.login/erasure-expired)
    {:heading (get outcome-headings action "Link no longer valid")
     :msg msg
     :config
     {:size :small
      :blur-bg? true}}))

(defmethod comms/receive :web.auth/erasure-link [app-atom response]
  (show! app-atom response))

(defmethod comms/receive :web.auth/erasure-answer [app-atom response]
  (show! app-atom response))

(defmethod flow/render-screen :web.login/erasure-confirm [app-atom _]
  (website/screen-wrapper app-atom
    (auth.cmn/auth-landing-page app-atom "erasure-confirm")
    {}))

(defmethod t/transition-open :web.login/erasure-confirm [app-atom _ _]
  (comms/ajax-post :web.auth/erasure-link {:token (link-token app-atom)}))
